import React, {useState, useEffect} from 'react';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import {
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import {fetchPartnerRevenueFields, fetchPartners} from '../../../../API/PartnerRevenue';
import DateRangeSelector from '../../../../components/date/DateRangeSelector';
import SelectMulti from '../../../../components/select/SelectMulti';
import useApi from '../../../../hooks/useApi';
import Cookies from 'js-cookie';

function PartnerRevenueOptionsForm({onSubmit}) {
    const {data: fields} = useApi(fetchPartnerRevenueFields);
    const {data: partners} = useApi(fetchPartners);

    const today = new Date();
    today.setHours(12, 0, 0, 0);
    const weekStart = new Date(today);
    weekStart.setDate(today.getDate() - 6);

    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const startformattedDate = formatLocalDate(weekStart);
    const endformattedDate = formatLocalDate(today);

    const [showPartner, setShowPartner] = useState(false);
    const [showType, setShowType] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState([]);
    const [selectedType, setSelectedType] = useState([]);

    const [options, setOptions] = useState({
        start_date: startformattedDate,
        end_date: endformattedDate,
        data: [],
        partner_id: [],
        type: [],
    });

    const types = [
        {name: 'DSP', id: 'DSP'},
        {name: 'SSP', id: 'SSP'},
    ];

    useEffect(() => {
        const storedValue = Cookies.get('PartnerRevenueReport');
        if (storedValue) {
            const parsed = JSON.parse(storedValue);
            delete parsed.start_date;
            delete parsed.end_date;
            delete parsed.company_id;
            setOptions((prev) => ({...prev, ...parsed}));
        }
    }, []);

    const handleDateChange = (selection) => {
        const endDate = new Date(selection.endDate);
        endDate.setHours(12, 12, 12, 12);
        const startDate = new Date(selection.startDate);
        startDate.setHours(12, 12, 12, 12);

        setOptions((prevOptions) => ({
            ...prevOptions,
            start_date: startDate.toISOString().split('T')[0],
            end_date: endDate.toISOString().split('T')[0],
        }));
    };

    const handleCheckboxChangeData = (event) => {
        const {name, checked} = event.target;
        let data = [...options.data];
        if (checked) {
            data.push(name);
        } else {
            data = data.filter((item) => item !== name);
        }
        setOptions({...options, data});
    };

    useEffect(() => {
        setOptions((prev) => ({...prev, partner_id: selectedPartner}));
    }, [selectedPartner]);

    useEffect(() => {
        setOptions((prev) => ({...prev, type: selectedType}));
    }, [selectedType]);

    const handleSubmit = () => {
        onSubmit(options);
    };

    return (
        <Grid container spacing={2} sx={{width: '100%', marginLeft: '0px'}}>
            <Accordion sx={{width: '100%'}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: '100%'}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: '100%'}}>
                    <Grid item xs={12} md={12} sx={{width: '100%', margin: '25px 0 25px auto'}}>
                        <Grid item xs={12} md={12}>
                            {Object.keys(fields).length !== 0 ? (<strong>Data</strong>) : ''}
                        </Grid>
                        {fields.map((field, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={options.data.includes(field.key)}
                                        onChange={handleCheckboxChangeData}
                                        name={field.key}
                                    />
                                }
                                label={field.value}
                            />
                        ))}
                    </Grid>

                    <Grid item xs={12} md={12} sx={{width: '100%', margin: '25px 0 25px auto'}}>
                        <Grid item xs={12} md={12}>
                            <strong>Filters</strong>
                        </Grid>
                        <FormControlLabel
                            control={<Checkbox checked={showPartner} onChange={() => setShowPartner(!showPartner)}/>}
                            label="Partner"
                        />
                        <FormControlLabel
                            control={<Checkbox checked={showType} onChange={() => setShowType(!showType)}/>}
                            label="Company type"
                        />
                        <Grid container spacing={2} sx={{marginTop: '8px'}}>
                            {showPartner && (
                                <Grid item xs={6}>
                                    <SelectMulti
                                        label="Partner"
                                        items={partners}
                                        selectedItems={selectedPartner}
                                        onChange={(event) => setSelectedPartner(event.target.value)}
                                        itemLabel="value.name"
                                        itemKey="value.id"
                                        itemValue="value.id"
                                    />
                                </Grid>
                            )}
                            {showType && (
                                <Grid item xs={6}>
                                    <SelectMulti
                                        label="Company type"
                                        items={types}
                                        selectedItems={selectedType}
                                        onChange={(event) => setSelectedType(event.target.value)}
                                        itemLabel="name"
                                        itemKey="id"
                                        itemValue="id"
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <Grid item xs={6} md={6}>
                <Button
                    size="large"
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px'}}
                >
                    Generate Report
                </Button>
            </Grid>
            <Grid item xs={6} md={6}>
                <DateRangeSelector
                    initialRange={{startDate: weekStart, endDate: today, key: 'selection'}}
                    onRangeChange={handleDateChange}
                />
            </Grid>
        </Grid>
    );
}

export default PartnerRevenueOptionsForm;
